import LiveStreamApi from "@/api/livestream/LiveStreamApi";

const state = {
  stream_name: '',
  switchStates: {
    publishing: false,
    recording: false
  },
  lastSaved: null
};

const mutations = {
  SET_STREAM_NAME(state, name) {
    state.stream_name = name;
  },
  TOGGLE_SWITCH(state, switchKey) {
    state.switchStates[switchKey] = !state.switchStates[switchKey];
  },
  SAVE_SUCCESSFUL(state) {
    state.lastSaved = new Date();
  }
};

const actions = {
  setStreamName({ commit }, name) {
    commit('SET_STREAM_NAME', name);
  },
  toggleSwitch({ commit, state }, switchKey) {
    commit('TOGGLE_SWITCH', switchKey);
  },
  async saveSettings({ commit, state }, data) {
    const response = await LiveStreamApi.saveStreamApi(data);
    if (response.status === 1) {
      commit('SAVE_SUCCESSFUL');
    }
    return response;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};